import { DataTableSortOrderType } from "primereact/datatable";

//export const baseUrl: string = "https://api.jobvritta.com/api/";
//export const baseUrl: string = "https://api.stage.jobvritta.com/api/";
// export const baseUrl: string = "https://localhost:62225/api/";
// export const baseUrl: string = "https://localhost:56411/api/";
// export const baseUrl: string = "https://admintestapi.jobvritta.com/api/";
// export const baseUrl: string = "https://localhost:52503/api/";
export const baseUrl: string = "https://api.teklense.com/api/";
// export const baseUrl: string = "https://portal.jobvritta.com/api/";
// export const baseUrl: string = "https://mirror-stg.jobvritta.com/api/";
// export const baseUrl: string = "https://adminapi.jobvritta.com/api/;
// export const hrLenseBaseUrl: string = "https://hrms-demo.jobvritta.com/api";
export const hrLenseBaseUrl: string = "https://hrmsapi.jobvritta.com/api";

export interface ILazyParams {
    first: number,
    rows: number,
    page: number,
    sortField: string,
    sortOrder: DataTableSortOrderType,
}

export const Fetch = async (url: string, method: "GET" | "POST" | "PUT" | "DELETE", body: any, query: string | null, toast: any) => {
    let params;

    params = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
        },
        ...(body && { body: JSON.stringify(body) })
    };

    try {
        const response = await fetch(`${baseUrl}${url}?${query}`, params);
        if (response.status === 401) {
            sessionStorage.clear();
            toast && toast.current.show({ severity: 'error', detail: "Unauthorized Please Login!", life: 3000 });
            window.location.href = '/login';
            return undefined;
        } else if (response.status === 400) {
            const message = await response.text();
            toast && toast.current.show({ severity: 'error', detail: message, life: 3000 });
            return undefined;
        } else if (response.status !== 200) {
            toast && toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
            return undefined;
        }
        return response;
    } catch {
        toast && toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        return undefined;
    }

}
